export default "__VITE_ASSET__$FRqFsdC__"